/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsersArrowRight: {
  name: 'users-arrow-right';
  data: string;
} = {
  name: 'users-arrow-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM4 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3 6a4 4 0 0 0-4 4 1 1 0 1 1-2 0 6 6 0 0 1 11-3.318A6 6 0 0 1 23 15a1 1 0 1 1-2 0 4 4 0 0 0-8 0 1 1 0 1 1-2 0 4 4 0 0 0-4-4Zm10-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm5.707 12.293-3-3a1 1 0 0 0-1.414 1.414L16.586 17H6a1 1 0 1 0 0 2h10.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414Z" fill="currentColor"/></svg>`,
};
